<div class="aacbc">
  <input type="checkbox" [(ngModel)]="val" [disabled]="isDisabled" (change)="valChanged($event)" />
</div>
